export const prodModels = [
  { value: 'GPBM-03-CA-12' },
  { value: 'GPBM-03-AU-12' },
  { value: 'GPBM-03-NZ-12' },
  { value: 'GPBM-03L-JP-01' },
  { value: 'GPBM-03L-AU-01' },
  { value: 'GPBM-03L-EU-01' },
  { value: 'GPBM-03L-CN-01' },
  { value: 'GPBM-03L-AF-01' },
  { value: 'GPBM-03H-AU-01' },
  { value: 'GPBM-03H-EU-01' },
  { value: 'GPBM-03-FLT-BP-01' },
  { value: 'GPBM-03-BTI-L-EU' },
  { value: 'GPBM-03-BTI-H' },
  { value: 'GPBM-03-BTI-L' },
  { value: 'GPBM-03-GE-EU-H' }, 
  { value: 'GPBM-03-GE-EU-L' }, 
  { value: 'GPBM-03-GE-US-H' }, 
  { value: 'GPBM-03-GE-US-L' }, 
  { value: 'GPBM-03-GE-ASIA-H' }, 
  { value: 'GPBM-03-GE-ASIA-L' },
  { value: 'GPBM-03-SI-01-H'}
]


export const netModels = [
  //EC20-CE,EC20-EA,EC25-AU,EC25-AF,EC25-EUX,EC25-J,M5700
  { value: 'EC20-CE' },
  { value: 'EC20-EA' },
  { value: 'EC25-AU' },
  { value: 'EC25-AF' },
  { value: 'EC25-EUX' },
  { value: 'EC25-J' },
  { value: 'M5700' }
]